module.exports = __webpack_public_path__ + "static/img/brian.55614aba.png";